import { defaultConfig } from './config';
import { initRender } from './render';
import { initEvents } from './events';
import { standardProtocol, getTitle, getUrl, showMenu, hideMenu } from './helper';
// eslint-disable-next-line import/prefer-default-export
export default class SlugShare {
  public shareConfig: ShareDialogOptions = {};
  public config: shareConsructorOptions = defaultConfig;
  public shareTo!: (channels: channelId) => Promise<void>;
  public constructor(options: UserConfig) {
    this.init(options);
  }

  public showMenu() {
    if (typeof this.config.onShareShow === 'function') {
      this.config.onShareShow();
    }
    showMenu();
  }

  public closeMenu() {
    if (typeof this.config.onShareClose === 'function') {
      this.config.onShareClose();
    }
    hideMenu();
  }

  public setShareConfig(options: UserConfig) {
    this.init({ ...this.config, ...options });
  }

  private getShareConfig(opt: UserConfig): ShareDialogOptions {
    return {
      title: getTitle(opt.title),
      url: getUrl(opt.url),
      imgUrl: standardProtocol(opt.imgUrl),
      desc: opt.desc,
      actName: opt.actName,
    };
  }

  private async init(opt: UserConfig) {
    this.config = { ...defaultConfig, ...opt };
    this.shareConfig = this.getShareConfig(this.config);
    await initEvents(this);
    initRender(this);
  }
};


// note: ������ window ��
if (typeof window !== 'undefined') {
  (window as any).SlugShare = SlugShare;
}
